import * as React from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ApplicationState } from '../store';
import * as AuthorizationStore from '../store/Authorization';
import * as CartStore from '../store/Cart';
import Loader from './shared/Loader';

function CartMenuIcon(props: {
    cartState: CartStore.IState,
    cartActions: typeof CartStore.actionCreators,
    authState: AuthorizationStore.IState
}) {

    useEffect(() => {

        if (props.authState.currentUser) {
            props.cartActions.getUserCartsTotalQty();
        }

    }, [props.authState.currentUser,
        props.cartState.itemAddedToCart,
        props.cartState.itemRemovedFromCart,
        props.cartState.updatedCartItem,
        props.cartState.cartDeleted,
        props.cartState.partnerItemsRemovedFromCart,
        props.cartState.cartOrderSent
    ])

    return <React.Fragment>
        {props.cartState.loadingTotalQuantity && <Loader /> }
        {!props.cartState.loadingTotalQuantity &&
            <span>
                <i className="fa fa-shopping-cart fa-lg"></i>{props.cartState.totalQuantity > 0 && <sup>{props.cartState.totalQuantity}</sup>}
            </span>
        }
    </React.Fragment>
}

export default connect((state: ApplicationState) => ({
    cartState: state.cart,
    authState: state.authorization
}), // Selects which state properties are merged into the component's props
    (dispatch, getState) => ({
        cartActions: bindActionCreators(CartStore.actionCreators, dispatch)
    }))(CartMenuIcon);
